
export class Report {

    id: string;
    displayName: string;
    description: string;
    page: string;
}
